import React, {useState} from 'react'
import {Alert} from '../../types/Alert'

import AlertList from './AlertList'
import SensorDetail from '../SensorList/SensorDetail'
import {SensorData, DoorSensorData} from '../../types/SensorData'
import {useNavigate} from 'react-router-dom'

interface AlertsPageProps {
  alerts: Alert[]
  sensors: (SensorData | DoorSensorData)[]
  onAlertClick?: (alert: Alert) => void
  onBack?: () => void
  macAddrToLabel?: (mac: string) => string
}

const AlertsPage: React.FC<AlertsPageProps> = ({
  alerts,
  sensors,
  onAlertClick,
  onBack,
  macAddrToLabel,
}) => {
  const [selectedSensor, setSelectedSensor] = useState<{
    macAddr: string
    type: 'temperature' | 'door'
  } | null>(null)

  const handleShowSensorDetail = (macAddr: string, type: 'temperature' | 'door') => {
    console.log('🔍 AlertsPage - handleShowSensorDetail called with:', macAddr, type)
    setSelectedSensor({macAddr, type})
    console.log(
      'Capteur sélectionné : ',
      sensors.find((s) => s.macAddr === macAddr)
    )
  }

  const handleCloseSensorDetail = () => {
    setSelectedSensor(null)
  }

  const getSensorData = (
    macAddr: string,
    type: 'temperature' | 'door'
  ): SensorData | DoorSensorData | undefined => {
    console.log(
      'Capteur sélectionné : ',
      sensors.find((s) => s.macAddr === macAddr)
    )
    return sensors.find((s) => s.macAddr === macAddr)
  }

  return (
    <div style={{padding: 24}}>
      {selectedSensor ? (
        <SensorDetail
          sensor={getSensorData(selectedSensor.macAddr, selectedSensor.type)!}
          type={selectedSensor.type}
          onBack={handleCloseSensorDetail}
        />
      ) : (
        <>
          <AlertList onBack={onBack} />
        </>
      )}
    </div>
  )
}

export default AlertsPage
